
import AlertInfo from './AlertInfo'
import AlertSuccess from './AlertSuccess'
import AlertError from './AlertError'

export default {
  name: 'Alerts',
  components: { AlertError, AlertSuccess, AlertInfo }
}
